/**
 * @generated SignedSource<<c089e6ba46e1902e7673ec4bcb2a1396>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedTitle_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTitle_item">;
  readonly " $fragmentType": "PdpRespSharedTitle_item";
};
export type PdpRespSharedTitle_item$key = {
  readonly " $data"?: PdpRespSharedTitle_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedTitle_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedTitle_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "26d47d000a910a1ce4296e4b926fa3a1";

export default node;
